const ResultsParams = `
adultsCount
arrival
childrenCount
currency
departure
filter
locale
maxBathrooms
maxBedrooms
maxPrice
minBathrooms
minBedrooms
minPrice
neLat
neLong
page
petIncluded
pinnedPropertyListing
q
regionId
searchbucket
searchTermUuid
swLat
swLong
zoom
`
    .trim()
    .split(/\s+/);

module.exports = {ResultsParams};
